// extracted by mini-css-extract-plugin
export var dataCell = "_l7-2";
export var dataRow = "_l7-0";
export var headerRow = "_l7-1";